import React, { CSSProperties, FC, ReactNode } from "react";
import { ResourceMeta as ResourceMetaType, ResourceMetaUpdate } from "../../../../hooks/useResourceMeta";
import { EditableMeta } from "./EditableMeta";
import { ReadOnlyMeta } from "./ReadOnlyMeta";

interface ResourceMetaProps {
  children?: ReactNode;
  extra?: ReactNode;
  childrenBefore?: boolean;
  meta?: ResourceMetaType;
  updateMeta?: ResourceMetaUpdate;
  onPreviewGenerate?: () => void;
  readOnly?: boolean;
  loading?: boolean;
  noMeta?: boolean;
  showCopyrightAndDescription?: boolean;
  showDescription?: boolean;
  showSystemName?: boolean;
  imageStyle?: CSSProperties;
}

const voidFn = () => null;

export const ResourceMeta: FC<ResourceMetaProps> = ({
  meta,
  updateMeta,
  onPreviewGenerate,
  readOnly,
  children,
  childrenBefore,
  loading,
  noMeta,
  imageStyle,
  showCopyrightAndDescription,
  showDescription,
  showSystemName,
  extra,
}) => {
  const { alias, description, preview, copyrightText } = meta;
  const {
    setAlias = voidFn,
    setDescription = voidFn,
    setPreview = voidFn,
    setCopyrightText = voidFn,
    setName = voidFn,
  } = updateMeta || {};

  return readOnly ? (
    <ReadOnlyMeta
      alias={alias}
      description={description}
      preview={preview}
      copyrightText={copyrightText}
      loading={loading}
      noMeta={noMeta}
      imageStyle={imageStyle}
      showCopyrightAndDescription={showCopyrightAndDescription}
      showDescription={showDescription}
      showSystemName={showSystemName}
      extra={extra}
    >
      {children}
    </ReadOnlyMeta>
  ) : (
    <EditableMeta
      meta={meta}
      setAlias={setAlias}
      setDescription={setDescription}
      setPreview={setPreview}
      onPreviewGenerate={onPreviewGenerate}
      setCopyrightText={setCopyrightText}
      loading={loading}
      childrenBefore={childrenBefore}
      showCopyrightAndDescription={showCopyrightAndDescription}
      showDescription={showDescription}
      showSystemName={showSystemName}
      setName={setName}
      extra={extra}
    >
      {children}
    </EditableMeta>
  );
};
